export default "__VITE_ASSET__BImUh3_x__"